import { Box, Container } from '@mui/material';

import ErrorBoundary from '@cvt/components/ErrorBoundary';

import { FeedbackSession as FeedbackSessionView } from '@modules/Feedback/views/FeedbackSession';


export const FeedbackSession = () => {
  return (
    <Box overflow="hidden">
      <Container disableGutters maxWidth="md">
        <ErrorBoundary>
          <FeedbackSessionView />
        </ErrorBoundary>
      </Container>
    </Box>
  );
};
